import React from "react";
import mobilecrossX from "../../../Assets/mobilecrossX.svg";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useNavigate } from "react-router-dom";
import {
  AI_PATH,
  CONTACT_US,
  FAQ_SCREEN,
  FAVORITES_LIST,
  JOI_TRAINING,
  LEGISLATIVE_MAP,
  TRACKING,
} from "../../../Utils/Constants";
import { logEvent } from "../../../Utils/Api";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Menu from "@mui/material/Menu";
import { alpha } from "@mui/material/styles";
import starActive from "../../..//Assets/staractive.svg";
import intell from "../../../Assets/intell.png";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import legislativemap from "../../../Assets/legislativemap.svg";
import faqicon from "../../../Assets/faqIcon.svg";
import joitraining from "../../../Assets/joitraining.svg";
import cellphone from "../../..//Assets/cellphone.svg";
import aiPathMobileIcons from "../../../Assets/m-aipath-icon.svg";
import aiProfileSidebarMobileRed from "../../../Assets/aiProfileSidebarMobileRed.svg";
import legislationMobile from "../../../Assets/legislation-icon-mobile.svg";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));
const MSidebar = ({ open, setOpen }) => {
  return (
    <div>
      <div className="main-sidebar-pages-and-addsearch-data">
        <div className={`all-sidebar-listitems`}>
          <div className="mobilecrossX-img" onClick={() => setOpen(false)}>
            <img src={mobilecrossX} alt="" />
          </div>

          <List>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={AI_PATH}
                selected={window.location.pathname === AI_PATH}
                onClick={() => logEvent("Ai path", "JOI")}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === AI_PATH ? (
                    <span className="outer_circle_sidebar">
                      <img src={aiProfileSidebarMobileRed} alt="" />
                    </span>
                  ) : (
                    // <img src={starFilled} alt="" />
                    <img src={aiProfileSidebarMobileRed} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={"Ai Path"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>

          <List>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={FAVORITES_LIST}
                selected={window.location.pathname === FAVORITES_LIST}
                onClick={() => logEvent("Favorites", "JOI")}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === FAVORITES_LIST ? (
                    <span className="outer_circle_sidebar">
                      <img src={starActive} alt="" />
                    </span>
                  ) : (
                    // <img src={starFilled} alt="" />
                    <img src={starActive} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={"Favorites"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
          <List>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={TRACKING}
                selected={window.location.pathname === TRACKING}
                onClick={() => logEvent("Competitive Intel", "JOI")}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === TRACKING ? (
                    <span className="outer_circle_sidebar">
                      <img src={intell} alt="" />
                    </span>
                  ) : (
                    <img src={intell} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={"Competitive Intel"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
          <List>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={"/aiprofile/0"}
                selected={window.location.pathname.includes("aiprofile")}
                onClick={() => logEvent("AI Profile", "JOI")}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <span className="outer_circle_sidebar_icon">
                    <AccountCircleOutlinedIcon />
                  </span>
                </ListItemIcon>
                <ListItemText
                  primary={"AI Profile"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
          <List>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={LEGISLATIVE_MAP}
                selected={window.location.pathname === LEGISLATIVE_MAP}
                onClick={() => logEvent("Legislative Map", "JOI")}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === LEGISLATIVE_MAP ? (
                    <span className="outer_circle_sidebar">
                      {/* <img src={legislativemap} alt="" /> */}
                      <img src={legislationMobile} alt="" />
                    </span>
                  ) : (
                    <img src={legislationMobile} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={"Legislative"}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
          <List component="div" disablePadding>
            {/* FAQ */}
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={FAQ_SCREEN}
                selected={window.location.pathname === FAQ_SCREEN}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === FAQ_SCREEN ? (
                    <span className="outer_circle_sidebar">
                      <img src={faqicon} alt="" />
                    </span>
                  ) : (
                    <img src={faqicon} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary="FAQ / Glossary"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={JOI_TRAINING}
                selected={window.location.pathname === JOI_TRAINING}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === JOI_TRAINING ? (
                    <span className="outer_circle_sidebar">
                      <img
                        src={joitraining}
                        alt=""
                        className="training-cap-icon"
                      />
                    </span>
                  ) : (
                    <img
                      src={joitraining}
                      alt=""
                      className="training-cap-icon"
                    />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary="JOI Training"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
            <ListItem
              disablePadding
              sx={{ display: "block" }}
              className="links-sidebar"
            >
              <ListItemButton
                component={Link}
                to={CONTACT_US}
                selected={window.location.pathname === CONTACT_US}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {window.location.pathname === CONTACT_US ? (
                    <span className="outer_circle_sidebar">
                      <img src={cellphone} alt="" />
                    </span>
                  ) : (
                    <img src={cellphone} alt="" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary="Contact Us"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </div>
      </div>
    </div>
  );
};
export default MSidebar;
